import {ValueObject} from '@s-ui/domain'

import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class HpSpecificationVehiclesValueObject extends ValueObject {
  #hp

  constructor({hp}) {
    super()
    this.#hp = hp
  }

  static HP_SUFFIX = 'cv'
  static KW_SUFFIX = 'kw'

  static hpToKw(hp) {
    return Math.round(hp / 1.341)
  }

  static hpToKwString({hp}) {
    return `${hp} ${HpSpecificationVehiclesValueObject.HP_SUFFIX} (${HpSpecificationVehiclesValueObject.hpToKw(hp)} ${
      HpSpecificationVehiclesValueObject.KW_SUFFIX
    })`
  }

  static empty() {
    return new HpSpecificationVehiclesValueObject({hp: SpecificationVehiclesValueObject.empty()})
  }

  static createFromId({id}) {
    if (!SpecificationVehiclesValueObject.isValidId({id})) return HpSpecificationVehiclesValueObject.empty()

    return new HpSpecificationVehiclesValueObject({
      hp: SpecificationVehiclesValueObject.createFromLiterals({
        id,
        name: HpSpecificationVehiclesValueObject.hpToKwString({hp: id})
      })
    })
  }

  get icon() {
    return this.#hp.icon
  }

  get id() {
    return this.#hp.id
  }

  get name() {
    return this.#hp.name
  }

  get value() {
    return this.#hp.value
  }

  isEmpty() {
    return this.#hp.isEmpty()
  }
}
